import React from 'react';
import { InsightsPage } from '#pages/insights-page/index.ts';
import { Routes, Route } from '@leagueplatform/routing';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { DYNAMIC_DASHBOARD_ENABLED } from '#constants/feature-flags.constants.ts';
import { AllRecordedData } from '#pages/all-recorded-data/all-recorded-data.tsx';
import { AllRecordedData as AllRecordedData2 } from '#pages/all-recorded-data2/all-recorded-data.tsx';
import { AllRecordedData as AllRecordedData3 } from '#pages/all-recorded-data3/all-recorded-data.tsx';
import { AllRecordedData as AllRecordedDataMasonry } from '#pages/all-recorded-data-masonry/all-recorded-data.tsx';
import { DataSources } from '#pages/data-sources/data-sources.tsx';
import { DataSourcesV3 } from '#pages/data-sources3/data-sources.tsx';
import { Details } from '#pages/details/details.tsx';
import { Details as Details2 } from '#pages/details2/details.tsx';
import { Details as Details3 } from '#pages/details3/details.tsx';
import { Details as Details4 } from '#pages/details4/details.tsx';
import { Details as Details5 } from '#pages/details5/details.tsx';
import { useIsSelfReportedDataEnabled } from '#hooks/use-is-self-reported-data-enabled.hook.ts';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { useDashboardConfig } from '#hooks/use-dashboard-config.ts';

export const DashboardRoutes = () => {
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'ABOUT_ME' }));
  const { data: isDynamicDashboardEnabled } = useFeatureFlagQuery(
    DYNAMIC_DASHBOARD_ENABLED,
  );
  const {
    masonry2MetricDetailsEnabled,
    metricDetailsMasonryConfigKey,
    allRecordedDataMasonryConfigKey,
  } = useDashboardConfig();
  const { isSelfReportedDataEnabled } = useIsSelfReportedDataEnabled();

  const showV1 = !isDynamicDashboardEnabled && !isSelfReportedDataEnabled;
  const showV2 = isDynamicDashboardEnabled && !isSelfReportedDataEnabled;
  const showV3 = isDynamicDashboardEnabled && isSelfReportedDataEnabled;
  const showV4 = masonry2MetricDetailsEnabled;
  const showV5 = !!metricDetailsMasonryConfigKey;
  const showAllRecordedDataMasonry = !!allRecordedDataMasonryConfigKey;

  return (
    <Routes>
      {showAllRecordedDataMasonry && (
        <Route
          path=":dataType/all-recorded-data"
          element={<AllRecordedDataMasonry />}
        />
      )}
      {showV3 && (
        <Route
          path=":dataType/all-recorded-data"
          element={<AllRecordedData3 />}
        />
      )}
      {showV2 && (
        <Route
          path=":dataType/all-recorded-data"
          element={<AllRecordedData2 />}
        />
      )}
      {showV1 && (
        <Route
          path=":dataType/all-recorded-data"
          element={<AllRecordedData />}
        />
      )}
      {/* small changes between V1 and V2 for the DataSources page, so both render the same component.  */}
      {(showV1 || showV2) && (
        <Route path=":dataType/data-sources" element={<DataSources />} />
      )}
      {showV3 && (
        <Route path=":dataType/data-sources" element={<DataSourcesV3 />} />
      )}
      {showV5 && <Route path=":dataType/details" element={<Details5 />} />}
      {showV4 && !showV5 && (
        <Route path=":dataType/details" element={<Details4 />} />
      )}
      {showV3 && !showV4 && !showV5 && (
        <Route path=":dataType/details" element={<Details3 />} />
      )}
      {showV2 && !showV4 && !showV5 && (
        <Route path=":dataType/details" element={<Details2 />} />
      )}
      {showV1 && !showV4 && !showV5 && (
        <Route path=":dataType/details" element={<Details />} />
      )}
      <Route element={<InsightsPage />} path="/*" />
    </Routes>
  );
};
